// important! use this import because CommonPersonnelResponse has Nullable values
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { EnumResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'

export enum DiagnosisConsultationStatusEnum {
    PENDING = 'PENDING',
    SOLVED = 'SOLVED'
}

export interface DiagnosisConsultationStatusEnumResponse extends EnumResponse {
    code: DiagnosisConsultationStatusEnum
}

// Object representing the detail of a consultation case for diagnose.
export interface DiagnosisConsultationResponse {
    id: number // consultation id
    observationsReceiver: Nullable<string> // observations done by the receiver
    observationsRequester: string // observations done by the requester
    receiver: CommonPersonnelResponse
    requester: CommonPersonnelResponse
    sendingDate: string // date in which the consultation is done by the requester
    solvedDate: Nullable<string> // date in which the consultation is solved by the receiver
    status: DiagnosisConsultationStatusEnumResponse
}

// Object that represents the necessary data for creating a consultation related to a case
export interface DiagnosisConsultationCreateRequest {
    receiverPersonnelId: number // receiver personnel id
    requesterObservations: string // observations of the requester
    requesterPersonnelId: number // requester personnel id
}

// Object that represents the necessary data for patching a consultation related to a case
export interface DiagnosisConsultationFinalizationRequest {
    receiverObservations: string // observations of the receiver
}
